export enum FeatureToggle {
  localeSelector = 'rt_locale_selector',
  impersonationBreakglass = 'rt_ipp_impersonation_breakglass',
}
